// Haptic feedback utility for mobile devices
export const triggerHapticFeedback = (type = 'light') => {
  if (typeof window !== 'undefined' && 'vibrate' in navigator) {
    switch (type) {
      case 'light':
        navigator.vibrate(10);
        break;
      case 'medium':
        navigator.vibrate(50);
        break;
      case 'heavy':
        navigator.vibrate(100);
        break;
      case 'success':
        navigator.vibrate([50, 50, 50]);
        break;
      case 'error':
        navigator.vibrate([100, 50, 100]);
        break;
      default:
        navigator.vibrate(10);
    }
  }
};

// Haptic feedback for button interactions
export const buttonHaptic = () => triggerHapticFeedback('light');

// Haptic feedback for successful actions
export const successHaptic = () => triggerHapticFeedback('success');

// Haptic feedback for errors
export const errorHaptic = () => triggerHapticFeedback('error');

// Haptic feedback for important actions
export const importantHaptic = () => triggerHapticFeedback('heavy');

// Alias for backward compatibility
export const hapticFeedback = triggerHapticFeedback;
